var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPowerpointGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B2B3B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.071.009l.11.011.334 11.11L.432 8.931l.011-.112c.564-5.337 5.162-9.232 10.36-8.835l.268.025zm-.669.754l-.19-.005C5.925.69 2.184 3.793 1.355 8.11l-.033.18 9.362 1.858-.283-9.386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.112 0c5.363.017 9.725 3.609 9.884 9.337l.004.292v.12L19.606 11h-9.494L10 0h.112zm.897 1.052l.093 8.947 7.77.001.127-.404-.003-.244c-.14-4.827-3.542-7.74-7.87-8.287l-.117-.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10v.11A9.918 9.918 0 0110.11 20h-.22C4.527 19.985.166 15.714.005 10.386L0 10h20zm-1.048.999H1.047l.016.144c.513 4.332 4.131 7.712 8.565 7.852l.48.005a8.92 8.92 0 008.83-7.855l.014-.146z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.698 6.11v9.21a.868.868 0 01-.851.87H3.219a9.487 9.487 0 01-1.824-5.609v-.21A9.471 9.471 0 012.893 5.24h6.954a.868.868 0 01.85.871z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.233 6.11v9.21a.868.868 0 01-.852.87H3.22a9.487 9.487 0 01-1.824-5.609v-.21A9.471 9.471 0 012.893 5.24h6.488a.868.868 0 01.852.871z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.853 5.239H9.38c.47 0 .853.39.853.873v8.73a.863.863 0 01-.853.872H.853A.863.863 0 010 14.842v-8.73c0-.482.382-.873.853-.873z",
    fill: "#B2B3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21 7.567a2.305 2.305 0 011.552.465c.373.341.572.839.54 1.35.006.354-.086.704-.266 1.007a1.795 1.795 0 01-.757.685c-.356.17-.745.253-1.138.245H4.062v2.052H2.958V7.567h2.251zm-1.15 2.865h.951c.301.023.6-.068.84-.256a.965.965 0 00.285-.751c0-.64-.363-.96-1.09-.96H4.06v1.967z",
    fill: "#FFF"
  }))));
}

export default SvgPowerpointGrey;